import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Batch } from '@paragon/contract-library';

export interface BatchesState {
  [batchGuid: string]: Batch;
}

const initialState: BatchesState = {};

const batchesSlice = createSlice({
  name: 'batches',
  initialState,
  reducers: {
    batchesLoaded: (state, action: PayloadAction<readonly Batch[]>) => {
      for (const batch of action.payload) {
        state[batch.guid] = castDraft(batch);
      }
    },
    batchCreated: (state, action: PayloadAction<Batch>) => {
      state[action.payload.guid] = castDraft(action.payload);
    },
    batchDeleted: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { batchesLoaded, batchCreated, batchDeleted } = batchesSlice.actions;
export const batches = batchesSlice.reducer;
